export const REFUND_SERVICES_PATH = {
	BASE: 'refund-services',
	SELECT: 'select',
	CREATE: 'create',
	REQUEST: 'request'
} as const;

const REFUND_SERVICES_BASE = `/${REFUND_SERVICES_PATH.BASE}` as const;

export const REFUND_SERVICES_ROUTES = {
	BASE: REFUND_SERVICES_BASE,
	SELECT: `${REFUND_SERVICES_BASE}/${REFUND_SERVICES_PATH.SELECT}`,
	CREATE: `${REFUND_SERVICES_BASE}/${REFUND_SERVICES_PATH.CREATE}`,
	REQUEST: `${REFUND_SERVICES_BASE}/${REFUND_SERVICES_PATH.REQUEST}`
};
